<app-payments></app-payments>
<router-outlet></router-outlet>

<div class="appp-1" *ngIf="showAppPopup && showMobileDownloadPopup">
  <div id="download_app" tabindex="-1" aria-labelledby="unlock_courseModalLabel"
  aria-hidden="true">
  <div>
      <div>
          <div class="cls-gp-ot">
              <button type="button" class="close" (click)="closeModal()">
                  <span aria-hidden="true" class="cls-ft">&times;</span>
               </button>
          </div>

          <div class="app-otr-hd">
            <div class="app-head-im">
              <img _ngcontent-rfm-c2="" width="{{imgWidth}}" height="{{imgHeight}}" src="assets/images/{{logo}}">
            </div>
            <div>
              <div class="app-head-nm">
                Use coupon "App" and get 10% Extra Discount
              </div>
            </div>
          </div>
          <div>
          </div>
          <div>
          </div>
          <div class="modal-body-mob">
            <div class="stars-rt-otr">
              <span style="color: black;font-weight: 600;">
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-392 394 14 14" style="enable-background:new -392 394 14 14;" xml:space="preserve" width="20" height="20">
  <g>
  <path style="fill:#ffcf00;" d="M-385.9,394.9l-1.5,3.1c-0.1,0.1-0.2,0.2-0.3,0.2l-3.4,0.5c-0.4,0.1-0.7,0.3-0.8,0.7c-0.1,0.4,0,0.8,0.3,1l2.5,2.4c0.1,0.1,0.2,0.2,0.1,0.4l-0.6,3.4c-0.1,0.3,0,0.6,0.2,0.8c0.3,0.4,0.8,0.5,1.2,0.2l3-1.6c0.1,0,0.1,0,0.2,0v-11.7C-385.4,394.3-385.7,394.5-385.9,394.9z">
  </path>
  <path style="fill:#ffcf00;" d="M-378.3,400.4c0.3-0.3,0.4-0.7,0.3-1c-0.1-0.4-0.4-0.6-0.8-0.7l-3.4-0.5c-0.1,0-0.3-0.1-0.3-0.2l-1.5-3.1c-0.2-0.3-0.5-0.6-0.9-0.6v11.7c0.1,0,0.1,0,0.2,0l3,1.6c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8l-0.6-3.4c0-0.1,0-0.3,0.1-0.4L-378.3,400.4z">
  </path>
  </g>
  </svg>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-392 394 14 14" style="enable-background:new -392 394 14 14;" xml:space="preserve" width="20" height="20">
  <g>
  <path style="fill:#ffcf00;" d="M-385.9,394.9l-1.5,3.1c-0.1,0.1-0.2,0.2-0.3,0.2l-3.4,0.5c-0.4,0.1-0.7,0.3-0.8,0.7c-0.1,0.4,0,0.8,0.3,1l2.5,2.4c0.1,0.1,0.2,0.2,0.1,0.4l-0.6,3.4c-0.1,0.3,0,0.6,0.2,0.8c0.3,0.4,0.8,0.5,1.2,0.2l3-1.6c0.1,0,0.1,0,0.2,0v-11.7C-385.4,394.3-385.7,394.5-385.9,394.9z">
  </path>
  <path style="fill:#ffcf00;" d="M-378.3,400.4c0.3-0.3,0.4-0.7,0.3-1c-0.1-0.4-0.4-0.6-0.8-0.7l-3.4-0.5c-0.1,0-0.3-0.1-0.3-0.2l-1.5-3.1c-0.2-0.3-0.5-0.6-0.9-0.6v11.7c0.1,0,0.1,0,0.2,0l3,1.6c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8l-0.6-3.4c0-0.1,0-0.3,0.1-0.4L-378.3,400.4z">
  </path>
  </g>
  </svg>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-392 394 14 14" style="enable-background:new -392 394 14 14;" xml:space="preserve" width="20" height="20">
  <g>
  <path style="fill:#ffcf00;" d="M-385.9,394.9l-1.5,3.1c-0.1,0.1-0.2,0.2-0.3,0.2l-3.4,0.5c-0.4,0.1-0.7,0.3-0.8,0.7c-0.1,0.4,0,0.8,0.3,1l2.5,2.4c0.1,0.1,0.2,0.2,0.1,0.4l-0.6,3.4c-0.1,0.3,0,0.6,0.2,0.8c0.3,0.4,0.8,0.5,1.2,0.2l3-1.6c0.1,0,0.1,0,0.2,0v-11.7C-385.4,394.3-385.7,394.5-385.9,394.9z">
  </path>
  <path style="fill:#ffcf00;" d="M-378.3,400.4c0.3-0.3,0.4-0.7,0.3-1c-0.1-0.4-0.4-0.6-0.8-0.7l-3.4-0.5c-0.1,0-0.3-0.1-0.3-0.2l-1.5-3.1c-0.2-0.3-0.5-0.6-0.9-0.6v11.7c0.1,0,0.1,0,0.2,0l3,1.6c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8l-0.6-3.4c0-0.1,0-0.3,0.1-0.4L-378.3,400.4z">
  </path>
  </g>
  </svg>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-392 394 14 14" style="enable-background:new -392 394 14 14;" xml:space="preserve" width="20" height="20">
  <g>
  <path style="fill:#ffcf00;" d="M-385.9,394.9l-1.5,3.1c-0.1,0.1-0.2,0.2-0.3,0.2l-3.4,0.5c-0.4,0.1-0.7,0.3-0.8,0.7c-0.1,0.4,0,0.8,0.3,1l2.5,2.4c0.1,0.1,0.2,0.2,0.1,0.4l-0.6,3.4c-0.1,0.3,0,0.6,0.2,0.8c0.3,0.4,0.8,0.5,1.2,0.2l3-1.6c0.1,0,0.1,0,0.2,0v-11.7C-385.4,394.3-385.7,394.5-385.9,394.9z">
  </path>
  <path style="fill:#ffcf00;" d="M-378.3,400.4c0.3-0.3,0.4-0.7,0.3-1c-0.1-0.4-0.4-0.6-0.8-0.7l-3.4-0.5c-0.1,0-0.3-0.1-0.3-0.2l-1.5-3.1c-0.2-0.3-0.5-0.6-0.9-0.6v11.7c0.1,0,0.1,0,0.2,0l3,1.6c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8l-0.6-3.4c0-0.1,0-0.3,0.1-0.4L-378.3,400.4z">
  </path>
  </g>
  </svg>
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-392 394 14 14" style="enable-background:new -392 394 14 14;" xml:space="preserve" width="20" height="20">
    <g>
    <path style="fill:#ffcf00;" d="M-385.9,394.9l-1.5,3.1c-0.1,0.1-0.2,0.2-0.3,0.2l-3.4,0.5c-0.4,0.1-0.7,0.3-0.8,0.7c-0.1,0.4,0,0.8,0.3,1l2.5,2.4c0.1,0.1,0.2,0.2,0.1,0.4l-0.6,3.4c-0.1,0.3,0,0.6,0.2,0.8c0.3,0.4,0.8,0.5,1.2,0.2l3-1.6c0.1,0,0.1,0,0.2,0v-11.7C-385.4,394.3-385.7,394.5-385.9,394.9z">
    </path>
    <path style="fill:#ffcf00;" d="M-378.3,400.4c0.3-0.3,0.4-0.7,0.3-1c-0.1-0.4-0.4-0.6-0.8-0.7l-3.4-0.5c-0.1,0-0.3-0.1-0.3-0.2l-1.5-3.1c-0.2-0.3-0.5-0.6-0.9-0.6v11.7c0.1,0,0.1,0,0.2,0l3,1.6c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8l-0.6-3.4c0-0.1,0-0.3,0.1-0.4L-378.3,400.4z">
    </path>
    </g>
    </svg>
  </span>
            </div>
            <ng-container *ngIf="playstoreLink">
              <a  href="{{playstoreLink}}">
                <div  class="extra-space">
                  <div class="text-download-app">
                    Download Free App
                  </div>
                </div>
              </a>
            </ng-container>
          </div>
      </div>
  </div>
</div>
</div>
